import React from "react";

import "../../styles/_licensingError.scss";

const LicensingError = () => (
  <div className="licensing-error">
    <h1 className="licensing-error-header">Licensing Error</h1>
    <p className="licensing-error-message">
      You are not licensed to sell insurance in the state where this client does
      business.
    </p>
    <p>
      Please contact our help desk at&nbsp;
      <span className="licensing-error-phone">(888) 644-6309</span>
    </p>
  </div>
);

export default LicensingError;
